import { withQuery } from "./query";
import { Get, Post } from "./request";
import { ClearCache } from "./recordService";

export function SaveView(
  dispatch,
  { AdvancedSearchNodes, EntityName, Fields, Filters, Id, Name }
) {
  return Post(dispatch, "saveview", "", {
    AdvancedSearchNodes,
    EntityName,
    Fields,
    Filters,
    Id,
    Name,
  });
}

export function RenameView(dispatch, { Id, Name }) {
  return Post(dispatch, "renameview", "", {
    Id,
    Name,
  });
}

export function DeleteView(dispatch, id) {
  return Get(dispatch, withQuery("deleteview", { id }));
}

export function Search(
  dispatch,
  successMessage,
  {
    EntityName,
    Fields,
    Filters,
    IsAdvancedSearch,
    IsExport,
    AdvancedSearchJoins,
    AdvancedSearchNodes,
    MarketingListId,
    MarketingListName,
    MarketingListScope = null,
    RemoveFromMarketingList,
    ReplaceExistingListMembers,
    PageRequested,
    PageSize,
    SelectedRecordIds = null,
  }
) {
  // search for records
  const method = IsAdvancedSearch
    ? "advancedentitysearch"
    : "entitysearch";
  return Post(dispatch, method, successMessage, {
    EntityName,
    Fields,
    Filters,
    IsExport,
    AdvancedSearchJoins,
    AdvancedSearchNodes,
    MarketingListId,
    MarketingListName,
    // Limits the search to the members, or the non-members, of a list.
    MarketingListScope,
    RemoveFromMarketingList,
    ReplaceExistingListMembers,
    PageRequested,
    PageSize,
    // Restricts the search, export or marketing list update to these records;
    // left out, it applies to every record the search matches.
    SelectedRecordIds,
  });
}

export function BulkEdit(dispatch, entityName, records) {
  ClearCache(entityName);
  return Post(dispatch, "bulkedit", "Records updated", {
    EntityName: entityName,
    Records: records,
  });
}
